import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaImages,
  FaEnvelopeOpenText,
  FaImage,
} from "react-icons/fa";

import AdminDashboard from "./AdminDashboard";
import AdminGallery from "./AdminGallery";
import Enquiries from "./Enquiries";
import AdminBanner from "./AdminBanner";

const menuItems = [
  {
    name: "Dashboard",
    icon: <FaTachometerAlt />,
  },
  {
    name: "Gallery",
    icon: <FaImages />,
  },
  {
    name: "Enquiries",
    icon: <FaEnvelopeOpenText />,
  },
  {
    name: "Banners",
    icon: <FaImage />,
  },
];

const AdminPanel = () => {
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  React.useEffect(() => {
    const isLogin = localStorage.getItem("adminLogin") === "true";
    const token = localStorage.getItem("adminToken");

    if (!isLogin || !token) {
      navigate("/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (confirmLogout) {
      localStorage.removeItem("adminLogin");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("admin");
      window.location.href = "/admin";
    }
  };

  return (
    <main className="h-screen bg-[#F4F8FF] overflow-hidden">
      <div className="flex h-screen overflow-hidden">
        <aside
          className={`fixed inset-y-0 left-0 z-50 w-[280px] h-screen bg-[#073B7A] text-white transform transition-transform duration-300 ${
            sidebarOpen
              ? "translate-x-0"
              : "-translate-x-full lg:translate-x-0"
          }`}
        >
          <div className="h-full flex flex-col">
            <div className="px-6 py-6 border-b border-white/15">
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="text-2xl font-bold text-[#F6C344]">
                    Admin Panel
                  </h1>
                  <p className="text-sm text-blue-50 mt-1">
                    Urban Agrotech Farm
                  </p>
                </div>

                <button
                  onClick={() => setSidebarOpen(false)}
                  className="lg:hidden text-xl"
                >
                  <FaTimes />
                </button>
              </div>
            </div>

            <nav className="flex-1 px-4 py-5 space-y-2 overflow-y-auto">
              {menuItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => {
                    setActiveMenu(item.name);
                    setSidebarOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-semibold transition ${
                    activeMenu === item.name
                      ? "bg-[#F6C344] text-[#073B7A]"
                      : "text-blue-50 hover:bg-white/10"
                  }`}
                >
                  <span className="text-lg">{item.icon}</span>
                  {item.name}
                </button>
              ))}
            </nav>

            <div className="px-4 py-5 border-t border-white/15">
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-xl font-semibold text-blue-50 hover:bg-red-500 transition"
              >
                <FaSignOutAlt />
                Logout
              </button>
            </div>
          </div>
        </aside>

        {sidebarOpen && (
          <div
            onClick={() => setSidebarOpen(false)}
            className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          ></div>
        )}

        <section className="flex-1 h-screen flex flex-col overflow-hidden lg:ml-[280px]">
          <div className="shrink-0 bg-white border-b border-[#D8E6FF] px-4 md:px-8 py-4 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden w-11 h-11 rounded-xl bg-[#0B4EA2] text-white flex items-center justify-center"
              >
                <FaBars />
              </button>

              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#073B7A]">
                  {activeMenu}
                </h2>
                <p className="text-sm text-gray-500">
                  Urban Agrotech Admin Dashboard
                </p>
              </div>
            </div>

            <div className="hidden sm:block text-right">
              <p className="font-bold text-[#073B7A]">Administrator</p>
              <p className="text-sm text-gray-500">Welcome Back</p>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-4 md:p-8">
            {activeMenu === "Dashboard" && <AdminDashboard />}
            {activeMenu === "Gallery" && <AdminGallery />}
            {activeMenu === "Enquiries" && <Enquiries />}
            {activeMenu === "Banners" && <AdminBanner />}
          </div>
        </section>
      </div>
    </main>
  );
};

export default AdminPanel;
